/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Room, RoomEvent } from "livekit-client";

export function useListenToGroupChange(
  room: Room | null | undefined,
  toggleHandler: () => void,
  disable?: boolean
) {
  useEffect(() => {
    if (!room || disable) return;

    const handler = (data: Uint8Array, _participant?: any, _kind?: any) => {
      try {
        const decoded = JSON.parse(new TextDecoder().decode(data));
        if (
          decoded.type === "group_created" ||
          decoded.type === "chat_cleared" ||
          decoded.type === "all_chat_cleared"
        ) {
          toggleHandler();
        }
      } catch {
        /* ignore invalid payloads */
      }
    };

    room.on(RoomEvent.DataReceived, handler);
    return () => {
      room.off(RoomEvent.DataReceived, handler);
    };
  }, [room, toggleHandler, disable]);
}
